import { InputGroup, InputLeftAddon, Select } from "@chakra-ui/react";
import { t } from "i18next";
import { getCategoryLabel, scopeThreeCategories } from "../helpers";

function CategorySelector({ selectedCategory, handleCategorySelection }) {
  return (
    <InputGroup display="flex" alignItems="center" width="400px" marginBlock={4}>
      <InputLeftAddon children={t("category")} fontWeight="semibold" />
      <Select
        backgroundColor="white"
        borderRadius="none"
        value={selectedCategory}
        onChange={(e) => handleCategorySelection(e.target.value)}
        title={selectedCategory ? getCategoryLabel(selectedCategory) : ""}
      >
        {scopeThreeCategories.map(cat => {
          return <option key={cat.value} value={cat.value}>
            {getCategoryLabel(cat.value)}
          </option>;
        })}
      </Select>
    </InputGroup>
  );
}

export default CategorySelector;